import { ExpertsResultsResponse } from '@interfaces/index';
import { MotionText } from '@shared/atoms';
import { ExpertsCarousel } from '@shared/organisms/Experts/ExpertsCarousel/ExpertsCarousel';
import React from 'react';
import { useHistory } from 'react-router';
import styles from './index.module.scss';

interface SectionProps {
  experts: ExpertsResultsResponse;
  expertsLoading: boolean;
  isNotDashboard?: boolean;
}

export const ExpertsSection: React.FC<SectionProps> = ({
  experts,
  expertsLoading,
  isNotDashboard,
}) => {
  const history = useHistory();

  return (
    <section className={styles.expSection} aria-labelledby="journey-heading">
      <div className={styles.expertSection}>
        {isNotDashboard ? (
          <MotionText
            id="recommended-heading"
            className={styles.sectionTitle}
            as="h3"
            text="Book a session with expert"
          />
        ) : (
          <MotionText
            id="recommended-heading"
            className={styles.sectionTitle}
            as="h4"
            text="Book a session with expert"
          />
        )}

        <ExpertsCarousel experts={experts} loading={expertsLoading} />

        {experts?.total === 0 && !expertsLoading && (
          <p className={styles.noPostsText}>No experts</p>
        )}
      </div>
    </section>
  );
};

ExpertsSection.defaultProps = {
  isNotDashboard: false,
};
